import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';

interface CancelSubscriptionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
  endsAtLabel?: string | null;
}

export default function CancelSubscriptionDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
  endsAtLabel,
}: CancelSubscriptionDialogProps) {
  const { t } = useTranslation('signatures');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#09090b] border-borderColor text-colorText">
        <DialogHeader>
          <DialogTitle>{t('details.cancel_confirm_title')}</DialogTitle>
          <DialogDescription className="text-muted">
            {endsAtLabel
              ? t('details.cancel_confirm_description_with_date', { date: endsAtLabel })
              : t('details.cancel_confirm_description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={isLoading}>
            {t('details.back')}
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? t('details.canceling') : t('details.cancel_subscription')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
